import { Component } from '@angular/core';
import { EventsModule } from '../../../../events/events.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-event-editor-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    EventsModule,
  ],
  templateUrl: './event-editor-dashboard-page.component.html',
  styleUrl: './event-editor-dashboard-page.component.sass',
})
export class EventEditorDashboardPageComponent { }
